import { NEW_SELLER_CATEGORIES, USED_SELLER_CATEGORIES } from './SignUpAccountSelect';
import { GARAGE_COMPANY_TYPES } from './partnerSignupBusiness';

export function buildAccountTypeMeta(accountSelection) {
  if (!accountSelection?.mainType) return {};
  if (accountSelection.mainType === 'garage') {
    const cat = GARAGE_COMPANY_TYPES.find((c) => c.value === accountSelection.sellerCategory);
    return {
      accountMainType: 'garage',
      accountTypeLabel: cat ? `${cat.label} (${cat.desc})` : 'Garage / workshop',
      partCondition: '',
      sellerCategory: accountSelection.sellerCategory || '',
      sellerCategoryLabel: cat?.label || accountSelection.sellerCategory || '',
    };
  }
  const cat = accountSelection.partCondition === 'used'
    ? USED_SELLER_CATEGORIES.find((c) => c.id === accountSelection.sellerCategory)
    : NEW_SELLER_CATEGORIES.find((c) => c.id === accountSelection.sellerCategory);
  const partLabel = accountSelection.partCondition === 'used' ? 'Used parts' : 'New parts';
  return {
    accountMainType: accountSelection.mainType,
    partCondition: accountSelection.partCondition || '',
    sellerCategory: accountSelection.sellerCategory || '',
    sellerCategoryLabel: cat?.label || accountSelection.sellerCategory || '',
    accountTypeLabel:
      accountSelection.partCondition === 'used'
        ? `${cat?.label || 'Used seller'} — ${partLabel}`
        : `${cat?.label || 'Seller'} — ${partLabel}`,
  };
}
